import type { Surface } from '../../common/types/surface/types';

export type { Surface };

let surfaceServiceInstance: SurfaceService | undefined;

/**
 * Returns the singleton {@link SurfaceService} instance.
 */
export function getSurfaceService(): SurfaceService {
	if (!surfaceServiceInstance) {
		surfaceServiceInstance = new SurfaceService();
	}
	return surfaceServiceInstance;
}

/**
 * Service that owns the host surface's contract with the native-embeds system.
 *
 * A surface encapsulates capabilities that differ per host (editor, renderer,
 * other products). The interface will grow as new surface concerns are
 * identified.
 *
 * - Call {@link setSurface} to register or replace the active surface.
 * - Pass `null` to clear the surface (e.g. on unmount).
 * - Last-write-wins: calling `setSurface` again replaces the previous surface.
 */
export class SurfaceService {
	private _surface: Surface | null = null;

	/**
	 * Register or replace the active host surface.
	 *
	 * @param surface - The surface configuration, or `null` to clear.
	 */
	setSurface(surface: Surface | null): void {
		this._surface = surface;
	}

	/**
	 * Returns the currently active surface, or `null` if none is set.
	 */
	getSurface(): Surface | null {
		return this._surface;
	}
}
